import { jsx as _jsx } from "react/jsx-runtime";
import { Help as IconHelp } from "@mui/icons-material";
import clsx from "clsx";
import { UiTooltip } from "../ui_tooltip";
import { useStyles } from "./ui_helper.css";
export const UiHelper = ({ title, variant = "info-gray", className, size, arrow = true, }) => {
    const classes = useStyles({ variant });
    return title ? (_jsx(UiTooltip, { arrow: arrow, classes: {
            tooltip: classes.tooltip,
        }, variant: variant, title: title, size: size, children: _jsx(IconHelp, { className: clsx(classes.icon, className), fontSize: "small" }) })) : (_jsx(IconHelp, { className: clsx(classes.icon, className), fontSize: "small" }));
};
//# sourceMappingURL=ui_helper.js.map